var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"m6Lqnb09zBQvGfjAG_nnR"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from '@sentry/nextjs';

// Define error message patterns and types to ignore
const IGNORED_ERROR_PATTERNS = [
  // Next.js routing related
  'Invariant: attempted to hard navigate to the same URL',
  'Cancel rendering route',
  
  // Browser security related
  'The operation is insecure',
  'Non-Error promise rejection captured',
  
  // Third-party library errors (Chrome/Safari/Firefox specific)
  'Script error',
  'ResizeObserver loop limit exceeded',
  'Network request failed',
  
  // Browser extension related
  'chrome-extension://',
  'moz-extension://',
];

// Define error types and events to ignore
const IGNORED_ERROR_TYPES = [
  'CustomEvent',
  'NetworkError',
];

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn:
    SENTRY_DSN ||
    'https://638691a2c66249c584cf272ba497eeda@o4504485130797056.ingest.us.sentry.io/4504516239425536',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.8, // Reduce sample rate to minimize noise
  enabled: process.env.NODE_ENV !== 'development',
  environment: process.env.NX_CUSTOM_ENV || 'production',
  
  // Ignore specific error patterns
  ignoreErrors: IGNORED_ERROR_PATTERNS,
  
  // Only report errors from the application
  allowUrls: [
    /^https:\/\/dashboard\.jove\.co/,
    /^https:\/\/jove-dashboard/,
  ],
  
  // Filter to ignore errors from browser extensions and content scripts
  beforeSend: (event, hint) => {
    const error = hint.originalException;
    
    // Check if error message should be ignored
    if (error instanceof Error) {
      const message = error.message || '';
      const stack = error.stack || '';
      
      // Match ignored error patterns
      if (IGNORED_ERROR_PATTERNS.some(pattern => message.includes(pattern))) {
        return null;
      }
      
      // Ignore errors from browser extensions
      if (stack.includes('chrome-extension://') || stack.includes('moz-extension://')) {
        return null;
      }
      
      // Ignore CustomEvent and unknown errors in unhandledrejection
      if (event.type === 'unhandledrejection' && IGNORED_ERROR_TYPES.some(type => message.includes(type))) {
        return null;
      }
    }
    
    // Check error values in the event
    if (event.exception) {
      const exceptions = event.exception.values || [];
      for (const exc of exceptions) {
        if (IGNORED_ERROR_PATTERNS.some(pattern => 
          (exc.value || '').includes(pattern) || 
          (exc.type || '').includes(pattern)
        )) {
          return null;
        }
      }
    }
    
    return event;
  },
  
  // Enhance breadcrumb information for better error context
  integrations: (integrations) => {
    return integrations.filter((integration) => {
      // Keep useful integrations, remove those that may create noise
      return !['Replay'].includes(integration.name);
    });
  },
  
  // Configure data scrubbing to hide sensitive information
  beforeBreadcrumb: (breadcrumb) => {
    // Remove breadcrumbs containing sensitive data
    if (breadcrumb.category === 'http.client' && breadcrumb.data?.url) {
      // Hide sensitive information like tokens in query parameters
      breadcrumb.data.url = breadcrumb.data.url.replace(/([?&]token|[?&]key)=([^&]*)/g, '$1=***');
    }
    return breadcrumb;
  },
});
